import React from 'react';
import { Google } from '../../../../assets/img/svg/icons';

const Depoimento: React.FC<{ foto: string, nome: string, text: string, cargo: string }> = ({ foto, nome, text, cargo }) => {
    return (
        <div className="bg-[#EFEFFF50] rounded-xl flex flex-col justify-center gap-4 p-8 drop-shadow-sm relative">
            <Google className='w-4 h-4 object-contain absolute right-4 top-4' />

            <div className="text-xs md:text-sm">
                {text}
            </div>

            <div className="flex gap-2 items-center">
                <div className="rounded-full h-12 w-12 border border-black/20 flex items-center justify-center overflow-hidden shrink-0">
                    <img src={foto} alt={nome} className='w-full h-full object-cover' />
                </div>

                <div className="flex flex-col">
                    <h4 className='font-semibold text-sm'>{nome}</h4>
                    <div className='text-xs'>{cargo}</div>
                </div>
            </div>
        </div>
    );
};

const DepoimentosSection: React.FC<{depoimentos: Array<{ foto: string, nome: string, cargo: string, texto: string }>}> = ({depoimentos}) => {
    return (
        <section className='py-8'>
            <div className="max-w-screen-lg mx-auto px-4">
                <h2 className="font-semibold text-2xl text-center">
                    Depoimentos
                </h2>

                <div className='grid md:grid-cols-3 gap-4 mt-8'>
                    {depoimentos.map((depoimento, index) => (
                        <Depoimento key={index} foto={depoimento.foto} nome={depoimento.nome} cargo={depoimento.cargo} text={depoimento.texto} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DepoimentosSection;